/* eslint-disable import/no-anonymous-default-export */
import { ReactComponent as LogoutSvg } from 'assets/logout.svg';
import { ReactComponent as DownloadSvg } from 'assets/download.svg';
import { ReactComponent as HistorySvg } from 'assets/history.svg';
import { ReactComponent as SaveSvg } from 'assets/save.svg';
import { ReactComponent as EditSvg } from 'assets/edit.svg';
import { ReactComponent as LoginSvg } from 'assets/login.svg';
import { ReactComponent as BackSvg } from 'assets/back.svg';
import { ReactComponent as DeleteSvg } from 'assets/delete.svg';
import { ReactComponent as AddSvg } from 'assets/add.svg';
import { ReactComponent as CancelSvg } from 'assets/cancel.svg';
import { ReactComponent as HomeSvg } from 'assets/home.svg';
import { ReactComponent as DocumentSvg } from 'assets/document.svg';
import { ReactComponent as FileSvg } from 'assets/file.svg';

// Export all Svgs used on the Button component based on visual name
export default {
  admin: {
    icon: <LoginSvg />,
  },
  logout: {
    icon: <LogoutSvg />,
  },
  download: {
    icon: <DownloadSvg />,
  },
  history: {
    icon: <HistorySvg />,
  },
  save: {
    icon: <SaveSvg />,
  },
  login: {
    icon: <LoginSvg />,
  },
  back: {
    icon: <BackSvg />,
  },
  edit: {
    icon: <EditSvg />,
  },
  delete: {
    icon: <DeleteSvg />,
  },
  add: {
    icon: <AddSvg />,
  },
  cancel: {
    icon: <CancelSvg />,
  },
  home: {
    icon: <HomeSvg />,
  },
  related: {
    icon: <DocumentSvg />,
    },
    copy: {
        icon: <FileSvg />,
    },
};
